export default __webpack_public_path__ + "static/media/back-img.18250717.jpg";